import { render, staticRenderFns } from "./MarketShowcaseTable.vue?vue&type=template&id=4fce3984&"
import script from "./MarketShowcaseTable.vue?vue&type=script&lang=js&"
export * from "./MarketShowcaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports